<template>
  <div>
    <v-notification></v-notification>
    <Modal
        :style="showModal ? 'display: block' : 'display: none'"
        :show="showModal"
        modal-class="sim-card-modal"
        @close="toggleShowModal"
    >
      <template #body v-if="this.isOpenedWindow">
        <statistic-by-phone-number-modal :selected-phone-number="selectedPhoneNumber">
        </statistic-by-phone-number-modal>
      </template>
    </Modal>
    <div class="sim-card-page__title">
      <img src="/img/svg/common/sim-card.svg" alt="">
      <h1>{{ getLocalization('Sim cards') }}</h1>
    </div>
    <div class="sim-card-page__content">
      <div class="sim-card-page__filter">
        <div>
          <div class="--label">{{getLocalization('Type of simcard')}}</div>
          <div class="d-flex flex-wrap justify-content-between">
            <div class="filter-button-group mb-3">
              <div :class="simStatus === 2 ? 'active' : ''" @click="simStatus = 2">{{ getLocalization('All sim cards') }}</div>
              <div :class="simStatus === 1 ? 'active' : ''" @click="simStatus = 1">{{ getLocalization('Online sim cards') }}</div>
              <div :class="simStatus === 3 ? 'active' : ''" @click="simStatus = 3">{{ getLocalization('Offline sim cards') }}</div>
            </div>
            <div class="button orange mb-3" @click="getList">{{ getLocalization('Apply filters') }}</div>
          </div>
          <multiselect
              v-model="filterCountries"
              :placeholder="getLocalization('Select country')"
              label="title"
              track-by="title"
              :options='countriesList'
              :option-height="40"
              :show-labels="false"
              :allow-empty="true"
              :multiple="true"
              :closeOnSelect="false"
          >
            <template slot="option" slot-scope="props">
              <img :src="props.option.img_path">
              <span>{{ props.option.title }}</span>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="sim-card-page__table">
        <base-table
            ref="baseTable"
            :columns="this.columns"
            table-class="vgt-table sim-card-page__table new-design-table"
            :wrapperFiltersData="{}"
            :per-page-default="perPage"
            :use-green-pagination-simple="true"
            :dynamic-sort="true"
            :render-list-to-show="listToShow">
          <template v-slot:base-table-row="props">
            <template v-if="props.column.field === 'phone'">
              +{{ props.formattedRow[props.column.field] }}
            </template>
            <template v-else-if="props.column.field === 'active' || props.column.field === 'status'">
              {{ getLocalization(props.formattedRow[props.column.field]) }}
            </template>
            <template v-else-if="props.column.field === 'country'">
              <div style="padding: unset!important;">
                {{ props.formattedRow[props.column.field] }}
              </div>
            </template>
            <template v-else-if="props.column.field === 'services'">
              <div :id="'sim-card-pc-' + props.row['phone']" class="--row-services --hidden">
                <div class="--services">
                  {{ props.formattedRow[props.column.field] }}
                </div>
                <div class="--more" data-bs-toggle="collapse" data-bs-delay="0" :href="'#sim-card-pc-' + props.row['phone']" role="button">
                  <img src="/img/svg/common/circle-arrow-down-primary.svg" alt="">
                </div>
              </div>
            </template>
            <template v-else-if="props.column.field === 'info'">
              <button class="button primary" @click="showPhoneStatisticModal(props.formattedRow)">
                {{ props.formattedRow[props.column.field] }}
              </button>
            </template>
            <template v-else>
              <td>{{ props.formattedRow[props.column.field] }}</td>
            </template>
          </template>
          <template v-slot:base-table-pagination-green-simple="props">
            <div class="activation-history-all__pagination">
              <green-custom-pagination
                  :total="filteredList.length"
                  :perPage="perPage"
                  :pageChanged="props.pageChanged"
                  :perPageChanged="props.pageChanged"
              ></green-custom-pagination>
            </div>
          </template>
        </base-table>
      </div>
      <div class="sim-card-page__cards">
        <div class="sim-card-card" v-for="(sim, index) in filteredList">
          <div class="--head">
            <div class="--row">
              <div class="--label">{{ getLocalization('Date') }}</div>
              <div class="--value">{{ sim.created_at }}</div>
            </div>
            <div class="--info">
              <button class="button primary" @click="showPhoneStatisticModal(sim)">
                {{ sim.info }}
              </button>
            </div>
          </div>
          <div class="--divider"></div>
          <div class="--row --column">
            <div class="--label">{{ getLocalization('Number') }}</div>
            <div class="--value">+{{ sim.phone }}</div>
          </div>
          <div class="--row --column">
            <div class="--label">{{ getLocalization('Country') }}</div>
            <div class="--value">{{ sim.country }}</div>
          </div>
          <div class="--row --column">
            <div class="--label">{{ getLocalization('Status') }}</div>
            <div class="--value">{{ sim.active }}</div>
          </div>
          <div class="--row --column">
            <div class="--label">{{ getLocalization('Port') }}</div>
            <div class="--value">{{ sim.login }}</div>
          </div>
          <div class="--row --column">
            <div class="--label">{{ getLocalization('Earned') }}</div>
            <div class="--value">{{ sim.sum }}</div>
          </div>
          <div class="--divider"></div>
          <div class="--row --column">
            <div class="--label">{{ getLocalization('Services') }}</div>
            <div :id="'sim-card-mobile-' + index" class="--services --hidden">
              <div class="--value">
                {{ sim.services }}
              </div>
              <div
                  class="--full"
                  data-bs-toggle="collapse"
                  :href="'#sim-card-mobile-' + index"
                  role="button"
              >
              <span class="--visible">
                Показать все сервисы
              </span>
                <span class="--hidden">
                Скрыть сервисы
              </span>
                <img src="/img/svg/common/arrow-down-thin.svg">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomPagination from "../../../components/table/pagination/customPagination.vue";
import Multiselect from "vue-multiselect";
import Modal from '../../../components/table/modalNew.vue';
import BaseAdminMixin from "../../../admin/components/mixins/BaseAdminMixin.vue";
import BaseTable from "../../../components/table/baseTable.vue";
import GreenCustomPagination from "../../../components/table/pagination/greenCustomPagination.vue";

export default {
  name: "simCardsStatisticTable",
  mixins: [
    BaseAdminMixin
  ],
  components: {
    GreenCustomPagination,
    CustomPagination,
    Multiselect,
    Modal,
    BaseTable
  },
  props: [
    'translations'
  ],
  data: function () {
    return {
      filteredList: [],
      initialSortBy: {
        field: 'sum',
        type: 'desc'
      },
      sumElem: {
        show: false,
        earned: 0
      },
      simStatus: 2,
      countriesList: [],
      filterCountries: [],
      filters: {},
      showFilters: true,
      perPage: 10,
      timeout: null,
      countries: [],
      showModal: false,
      selectedPhoneNumber: null,
      isOpenedWindow: false,
      columns: [
        {
          label: this.getLocalization('Number'),
          sortable: false,
          field: 'phone',
        },
        {
          label: this.getLocalization('Date'),
          field: 'created_at',
          sortable: true,
          sortByColumn: 'created_at',
        },
        {
          label: this.getLocalization('Status'),
          sortable: false,
          field: 'active',
        },

        {
          label: this.getLocalization('Port'),
          field: 'login',
          sortable: true,
        },
        {
          label: this.getLocalization('Earned'),
          field: 'sum',
          sortable: true,
        },
        {
          label: this.getLocalization('Services'),
          field: 'services',
          sortable: false,
        },
        {
          label: this.getLocalization('Country'),
          field: 'country',
          sortable: true,
        },
        {
          label: this.getLocalization('Info'),
          field: 'info',
          sortable: false,
        },
      ]
    };
  },
  async mounted() {
    await this.getAvailableCountries();
  },

  methods: {
    listToShow(actualSimStatus) {
      let data = [];
      this.sumElem.earned = 0;
      for (let elem of actualSimStatus) {
        this.sumElem.earned += elem['sum'];
        this.sumElem.show = true;
        data.push({
          phone: elem['phone'],
          updated_at: elem['updated_at'],
          created_at: elem['created_at'],
          last_online: elem['last_online'],
          active: elem['active'],
          country: elem['country'],
          login: elem['login'].split('_')[0],
          sum: Number(elem['sum']).toFixed(2),
          info: elem['info'] ? this.getLocalization(elem['info']) : this.getLocalization('Info'),
          services: elem['services'].join(','),
        });
      }

      this.filteredList = data;
      return data;
    },

    showPhoneStatisticModal(phoneInfo) {
      this.selectedPhoneNumber = phoneInfo.phone
      this.toggleShowModal();
    },

    toggleShowModal() {
      this.showModal = !this.showModal;
      this.isOpenedWindow = !this.isOpenedWindow;
    },
    async getList() {
      await this.doWithStopRequest(async () => {
        let params = {
          simStatusId: this.simStatus,
          countriesIds: this.filterCountries.map(el => el.id)
        };
        let response = await this.sendRequest(
            '/cabinet/partner/simcardsstatistic/getList',
            'get',
            params);
        if (response) {
          this.$refs.baseTable.setFilteredList(response);
        }
      });
    },
    async getAvailableCountries() {
      let list = await this.sendRequest('/countries/getList', 'get');
      this.countriesList = list.map(el => {
        el.title = this.getLocalization(el.title);
        return el;
      });
    },
  },
}
</script>

